export function isValidProviderResult(res) {

  return res.ok && !!res.data;
}

export function isValidEmail(email) {

  if (typeof email !== 'string') {
    return false;
  }

  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
}

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) return phoneNumber;
  
  phoneNumber = String(phoneNumber);
  
  // Remove any whitespace
  phoneNumber = phoneNumber.replace(/\s+/g, '');
  
  // If the phone number starts with '0', replace it with '+27'
  if (phoneNumber.startsWith('0')) {
    return '+27' + phoneNumber.substring(1);
  }
  
  // If it doesn't start with '+', add it
  if (!phoneNumber.startsWith('+')) {
    return '+' + phoneNumber;
  }
  
  return phoneNumber;
};

export function isValidPhoneNumber(phone) {

  if (!phone) {
    return false;
  }

  phone = formatPhoneNumber(phone);

  return phone.startsWith('+27') && phone.length === 12;
}